export default "/images/gift.svg?ded019c1379db2778a36dc7d496332bf";